/**
 * @typedef {{ left: number; top: number; right: number; bottom: number }} Rect
 */

/**
 * @param {Rect} a
 * @param {Rect} b
 */
export function rectsIntersect(a, b) {
  return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
}

/**
 * @param {Rect} rect
 * @param {number} scale
 * @returns {Rect}
 */
export function getScaledRect(rect, scale) {
  const centerX = (rect.left + rect.right) / 2;
  const centerY = (rect.top + rect.bottom) / 2;
  const halfW = ((rect.right - rect.left) * scale) / 2;
  const halfH = ((rect.bottom - rect.top) * scale) / 2;

  return {
    left: centerX - halfW,
    top: centerY - halfH,
    right: centerX + halfW,
    bottom: centerY + halfH,
  };
}

/**
 * @param {number} col
 * @param {number} row
 * @param {{ gridOffsetX: number; padding: number; gap: number; tileWidth: number; tileHeight: number }} metrics
 * @returns {Rect}
 */
export function getTileRect(col, row, metrics) {
  const { gridOffsetX, padding, gap, tileWidth, tileHeight } = metrics;

  return {
    left: gridOffsetX + col * (tileWidth + gap),
    top: padding + row * (tileHeight + gap),
    right: gridOffsetX + col * (tileWidth + gap) + tileWidth,
    bottom: padding + row * (tileHeight + gap) + tileHeight,
  };
}

/**
 * @param {DOMRect} elementRect
 * @param {DOMRect} containerRect
 * @param {number} padding
 * @returns {Rect}
 */
export function getRectFromDom(elementRect, containerRect, padding) {
  return {
    left: elementRect.left - containerRect.left - padding,
    top: elementRect.top - containerRect.top - padding,
    right: elementRect.right - containerRect.left + padding,
    bottom: elementRect.bottom - containerRect.top + padding,
  };
}

/** @deprecated use getRectFromDom */
export function getTextBlockFromDom(elementRect, containerRect, padding) {
  return getRectFromDom(elementRect, containerRect, padding);
}

/**
 * @param {Rect | null} tileRect
 * @param {Rect[]} wordBlocks
 * @param {number} scale
 */
export function tileCollidesWithWords(tileRect, wordBlocks, scale) {
  if (!wordBlocks.length || !tileRect) {
    return false;
  }

  const bounds = scale > 1.02 ? getScaledRect(tileRect, scale) : tileRect;
  return wordBlocks.some((word) => rectsIntersect(bounds, word));
}

/**
 * @param {Rect | null} tileRect
 * @param {Rect | null} textBlock
 * @param {number} scale
 */
export function tileCollidesWithText(tileRect, textBlock, scale) {
  if (!textBlock || !tileRect) {
    return false;
  }

  return tileCollidesWithWords(tileRect, [textBlock], scale);
}
